import React, { useState } from "react";
import "./faq.css";

const faqs = [
  {
    question: "How long does it take to build a website?",
    answer:
      "On average, a basic website takes 1-2 weeks. Larger, more complex projects may take 4-6 weeks depending on requirements.",
  },
  {
    question: "Do I need hosting?",
    answer:
      "Yes, hosting is required to make your website live on the internet. We also assist with domain and hosting setup.",
  },
  {
    question: "Will my website be mobile-friendly?",
    answer:
      "Absolutely! All websites we build are fully responsive and optimized for mobile, tablet, and desktop devices.",
  },
  {
    question: "Do you provide logo design services?",
    answer:
      "Yes, we create modern, professional, and brand-focused logo designs that reflect your business identity.",
  },
  {
    question: "What is included in website development?",
    answer:
      "Our website development covers design, coding, responsive layouts, integrations, and performance optimization.",
  },
  {
    question: "Do you handle social media management?",
    answer:
      "Yes, we manage your social media profiles, create engaging content, and help you grow your online audience.",
  },
  {
    question: "What does digital marketing include?",
    answer:
      "Our digital marketing services include SEO, social media campaigns, paid ads, and content strategy to increase brand visibility.",
  },
  {
    question: "What is the SEO process you follow?",
    answer:
      "We follow a step-by-step SEO process: keyword research, on-page optimization, content strategy, link building, and performance tracking.",
  },
  {
    question: "Can you also manage my domain and hosting?",
    answer:
      "Yes, we provide complete domain registration and hosting setup services, ensuring your website runs smoothly.",
  },
  {
    question: "Will I be able to update my website myself?",
    answer:
      "Yes, we build user-friendly websites with admin panels so you can easily update content, images, and services.",
  },
  {
    question: "Do you provide ongoing website support?",
    answer:
      "Yes, we offer maintenance packages that include updates, backups, security checks, and performance improvements.",
  },
  {
    question: "Can you redesign my existing website?",
    answer:
      "Of course! We specialize in redesigning outdated websites into modern, responsive, and high-converting platforms.",
  },
  {
    question: "Do you provide e-commerce website solutions?",
    answer:
      "Yes, we build secure, scalable e-commerce websites with payment gateway integration and product management systems.",
  },
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      {/* <h2 className="faq-title">Frequently Asked Questions</h2> */}
       <section className="section-margin">
          <div className="heading-for-all"  data-aos="fade-up">
            <h2 >Frequently Asked Questions</h2>
          </div>
        </section>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{faq.question}</h3>
              <span>{activeIndex === index ? "−" : "+"}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
